module.exports = __webpack_public_path__ + "static/media/pop.651e9810.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/partner-reports/pop.svg
// module id = 1121
// module chunks = 1